module.exports = __webpack_public_path__ + "static/media/phone-call.5f3b84b7.svg";